<div class="back-button">
    <div class="d-flex justify-content-between align-items-center">
        <i-bs class="me-1" name="arrow-left"></i-bs>
        <div class="mb-1">previous</div>
    </div>
</div>
